export const useCustomSeoMeta = ({
	title,
	description,
	image
}: {
	title: Ref<string> | ComputedRef<string>;
	description: Ref<string> | ComputedRef<string>;
	image: Ref<string | undefined> | ComputedRef<string | undefined> | undefined;
}) => {
	const { public: publicConfig } = useRuntimeConfig();

	const defaultOgImage = `${publicConfig.siteUrl}/og-image.png`;

	useSeoMeta({
		titleTemplate: (titleChunk) => (titleChunk ? `Kippie.nl  - ${titleChunk}` : "Kippie.nl"),
		title: () => title.value,
		description: () => description.value,
		ogTitle: () => `Kippie.nl - ${title.value}`,
		ogDescription: () => description.value,
		ogImage: () => image?.value ?? defaultOgImage,
		ogUrl: () => publicConfig.siteUrl,
		ogSiteName: "Kippie",
		ogLocale: "nl_NL",
		ogType: "website",
		twitterTitle: () => `Kippie.nl - ${title.value}`,
		twitterDescription: () => description.value,
		twitterImage: () => image?.value ?? defaultOgImage,
		twitterCard: "summary_large_image"
	});
};
